var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('c-header'),_vm._v(" "),_c('s-hero'),_vm._v(" "),_c('s-ceo'),_vm._v(" "),_c('s-company'),_vm._v(" "),_c('s-fiber'),_vm._v(" "),_c('s-business'),_vm._v(" "),_c('s-innovation'),_vm._v(" "),_c('s-sustainability'),_vm._v(" "),_c('s-financials'),_vm._v(" "),_c('c-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a029b99c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 